import { call, takeLatest } from 'redux-saga/effects';
import { OUTSIDE_API } from '../../../consts/endpoints';
import RESPONSE_CODES from '../../../consts/responseCodes';
import { deleteData } from '../../../utils/http';
import showSnackbar from '../../../utils/showSnackbar';
import { fetchExternalNoRanges } from './getExternalNoRanges';
import { actions as sagaActions, DELETE_CONNECT_RANGE } from './types';

export function deleteConnectRange({ numberRange, resetValues }) {
  return {
    type: sagaActions[DELETE_CONNECT_RANGE],
    numberRange,
    resetValues
  };
}

export function* removeConnectRange({ numberRange, resetValues }) {
  const { range_from, range_up_to_incl } = numberRange;
  const { connectClientId } = resetValues;
  try {
    const response = yield call(deleteData, {
      url: `${OUTSIDE_API.EXTERNAL_NO_RANGES}/${connectClientId}/number_ranges?range_from=${range_from}&range_up_to_incl=${range_up_to_incl}`
    });

    if (response.status === RESPONSE_CODES.ACCEPTED) {
      yield call(showSnackbar, {
        intlTextKey: 'MESSAGE.DELETE_RANGE',
        messageType: 'success'
      });

      yield call(fetchExternalNoRanges, { ...resetValues });
    }
  } catch {
    return false;
  }
}

function* watchDeleteConnectRange() {
  yield takeLatest(sagaActions[DELETE_CONNECT_RANGE], removeConnectRange);
}

export default watchDeleteConnectRange();
